import type { AppConfigInput } from 'nuxt/schema'
import type { StrapiWebsiteConfig } from '../types/strapi'

export default defineAppConfig<AppConfigInput & {
  website: Pick<StrapiWebsiteConfig, 'analytic'>
}>({
  // siteName: "Default App Name",
  // themeColor: "#000000",
  // features: {
  //   enableChat: false,
  //   enableDarkMode: false,
  // },

  ui: {
    colors: {
      primary: 'violet',
      neutral: 'zinc',
    },
  },
  /**
   * Website config from Strapi
   * set clean field's for type generation
   */
  website: {
    analytic: {
      meta_pixel_id: '',
      google_analytics_id: '',
      plausible_enabled: false,
      plausible_api_host: '',
    },
  },
})
